import { CopyOutlined, PrinterOutlined } from '@ant-design/icons';
import { QRCodePrintTemplate } from '@components';
import { AppConsts, L } from '@lib';
import { Button, Col, Input, Modal, Row, Typography, message } from 'antd';
import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

const { Text } = Typography;

interface IProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  companyLogo: string | undefined;
}

export const ShareGarageModal: React.FC<IProps> = ({ visible, setVisible, companyLogo }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({ contentRef });

  const onCopy = () => {
    navigator.clipboard
      .writeText(AppConsts.mobileAppUrl)
      .then(() => message.success({ content: L('Copied') }));
  };

  return (
    <Modal
      onCancel={() => setVisible(false)}
      title={L('Share garage')}
      open={visible}
      footer={null}
    >
      <Row justify="center">
        <Text strong>{L('Print the QR code')}</Text>
      </Row>
      <br />
      <Row justify="center">
        <Button onClick={() => handlePrint()} icon={<PrinterOutlined />} type="primary">
          {L('Print')}
        </Button>
      </Row>
      <br />
      <Row ref={contentRef} justify="center" style={{ maxHeight: '25vh', marginBottom: '20px' }}>
        <QRCodePrintTemplate companyLogo={companyLogo} />
      </Row>
      <br />
      <Row justify="center">
        <Text strong>{L('Or share the URL')}</Text>
      </Row>
      <br />
      <Row justify="space-between">
        <Col span={17}>
          <Input readOnly value={AppConsts.mobileAppUrl} />
        </Col>
        <Col span={6}>
          <Button icon={<CopyOutlined />} onClick={onCopy}>
            {L('Copy Link')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
